import { render, staticRenderFns } from "./PromotionMonitoringReport.vue?vue&type=template&id=af84ef86"
import script from "./PromotionMonitoringReport.vue?vue&type=script&lang=js"
export * from "./PromotionMonitoringReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports